import {
    JsonObject,
    JsonProperty
} from "json2typescript";

@JsonObject("Asset")
export class Asset {
    @JsonProperty("id", String)
    id: string = "";

    @JsonProperty("name", String)
    name: string = "";

    @JsonProperty("url", String)
    url: string = "";

    @JsonProperty("width", Number)
    width: number = 0;

    @JsonProperty("height", Number)
    height: number = 0;
}